export const content = {
  maxWidth: '1888px',
  seaBoxDetailPanelMaxWidth: '1150px',
  cmsModuleMaxWidth: '1520px',
  // apply module-margin to achieve the same width than the product-listing
  cmsModuleMargin: true,
};
